import type { Fee } from '../types'
import { members } from './members'

const placljivi = members.filter((m) => m.type !== 'nekdanji')

function znesekZa(type: string): number {
  if (type === 'castni') return 0
  if (type === 'gostujoci') return 30
  return 60
}

const fees2026: Fee[] = placljivi.map((m, i) => ({
  memberId: m.id,
  leto: 2026,
  znesek: znesekZa(m.type),
  placano: true,
  datumPlacila: `2026-0${(i % 4) + 1}-${String((i % 26) + 2).padStart(2, '0')}`,
}))

const fees2027: Fee[] = placljivi.map((m, i) => ({
  memberId: m.id,
  leto: 2027,
  znesek: znesekZa(m.type),
  placano: i % 7 === 0 || m.type === 'castni',
  datumPlacila: i % 7 === 0 || m.type === 'castni' ? '2026-11-10' : undefined,
}))

export const fees: Fee[] = [...fees2026, ...fees2027]

export const feeYears = [2026, 2027]
